import { Config, Result } from "../types"
import _ from "underscore"
import ko from "knockout"
import $ from "jquery"
import { IndexListView } from "./IndexListView"
import { SearchBarView } from "./SearchBarView"
import { ItemListView } from "./ItemListView"
import { SidebarView } from "./SidebarView"
import { PagingView } from "./PagingView"
import { SorterView } from "./SorterView"

const EMPTY_RESULT = {
    indexes:    [],
    noResults:  false,
    query:      "",
    textAll:    "",
    textEmpty:  "",
    totalItems: 0,
    urlAll:     "",
}

export class PageView {
    visible: KnockoutObservable<boolean>
    loading: KnockoutObservable<boolean>
    preventRequest: KnockoutObservable<boolean>
    sendRequest: () => void
    xhr: JQueryXHR | null
    config: Config
    page: KnockoutObservable<number>
    result: KnockoutObservable<Result>
    time: KnockoutObservable<number>
    prevSearchRequest: object

    activeIndex: KnockoutObservable<string>
    searchQuery: KnockoutObservable<string>
    order: KnockoutObservable<string>
    direction: KnockoutObservable<string>
    isActiveDirection: KnockoutObservable<boolean>
    filterList: KnockoutObservable<Map<string, string>>

    searchBarView: SearchBarView
    indexListView: IndexListView
    itemListView: ItemListView
    sidebarView: SidebarView
    pagingView: PagingView
    sorterView: SorterView

    constructor(config: Config) {
        this.config = config
        this.prevSearchRequest = this.getPrevSearchRequest()
        this.page = ko.observable(1)
        this.visible = ko.observable(false)
        this.loading = ko.observable(false)
        this.preventRequest = ko.observable(false)
        this.searchQuery = ko.observable("")
        this.order = ko.observable(config.defaultOrder)
        this.direction = ko.observable(this.prevSearchRequest.direction)
        this.isActiveDirection = ko.observable(false)
        this.activeIndex = ko.observable("magento_catalog_product")
        this.filterList = ko.observable(new Map<string, string>())
        this.sendRequest = _.debounce(this.request, 10)
        this.xhr = null
        this.result = ko.observable(EMPTY_RESULT)
        this.time = ko.observable(0)

        this.searchBarView = new SearchBarView({
            result:          this.result,
            query:           this.searchQuery,
            visible:         this.visible,
        })

        this.indexListView = new IndexListView({
            result:          this.result,
            activeIndex:     this.activeIndex,
        })

        this.itemListView = new ItemListView({
            result:          this.result,
            activeIndex:     this.activeIndex,
        })

        this.sidebarView = new SidebarView({
            result:          this.result,
            activeIndex:     this.activeIndex,
            filterList:      this.filterList,
        })

        this.pagingView = new PagingView({
            result:          this.result,
            activeIndex:     this.activeIndex,
            page:            this.page,
        })

        this.sorterView = new SorterView({
            result:            this.result,
            order:             this.order,
            direction:         this.direction,
            isActiveDirection: this.isActiveDirection,
            availableOrders:   config.availableOrders,
        })

        this.visible.subscribe(visible => {
            $("html").toggleClass("mstInPage", visible)
        })

        $(document).on("keyup", e => {
            if (e.key === "Escape") {
                this.searchQuery() == "" && this.visible(false)
            }
        })

        this.searchQuery.subscribe(this.sendRequest)
        this.filterList.subscribe(this.sendRequest)
        this.page.subscribe(this.sendRequest)
        this.order.subscribe(this.sendRequest)
        this.direction.subscribe(this.sendRequest)
        this.activeIndex.subscribe(this._updateSavedRequest)
    }

    isEmpty = () => {
        return this.searchQuery() === "" || this.time() === 0
    }

    hide = () => {
        this.visible(false)
    }

    request = () => {
        this.xhr?.abort()

        if (this.preventRequest()) {
            this.preventRequest(false)

            return
        }

        if (this.searchQuery() === "") {
            this.result(EMPTY_RESULT)
            this.time(0)

            return
        }

        const ts = new Date().getTime()

        this.loading(true)
        let filters: any = {}

        this.filterList.subscribe(() => {
            this.page(1)
        })

        if (this.result().query == this.searchQuery()) {
            this.filterList().forEach((value, key) => filters[key] = value)
        } else {
            this.page(1)
            this.filterList().clear()
            filters = {}
        }

        let dataToSend = {
            q:             this.searchQuery(),
            store_id:      this.config.storeId,
            cat:           false,
            limit:         this.config.limit,
            p:             this.page(),
            index:         this.activeIndex(),
            buckets:       [ "category_ids" ],
            filters:       filters,
            order:         this.order(),
            direction:     this.direction(),
            is_active_dir: this.isActiveDirection(),
            currency:      this.config.currency,
        }

        this.xhr = $.ajax({
            url:      this.config.url,
            dataType: "json",
            type:     "GET",
            data:     dataToSend,
            success:  (data: Result) => {
                this.loading(false)
                this.result(data)

                let shouldSwitchActiveIndex = false

                _.each(data.indexes, index => {
                    if (index.identifier == this.activeIndex() && index.totalItems === 0) {
                        shouldSwitchActiveIndex = true
                    }

                    if (index.identifier === "magento_catalog_product" && index.sorter.direction !== this.direction()) {
                        $('.mstInPage__sorter .sorter-action.sorter-' + this.direction()).hide()
                        $('.mstInPage__sorter .sorter-action.sorter-' + index.sorter.direction).show()
                        this.preventRequest(true)
                        this.direction(index.sorter.direction)
                    }
                })

                if (shouldSwitchActiveIndex) {
                    const idx = _.find(data.indexes, idx => {
                        return idx.totalItems > 0
                    })
                    if (idx) {
                        this.activeIndex(idx.identifier)
                    }
                }

                this._saveRequest(dataToSend)

                this.isActiveDirection(false)
                this.time((new Date().getTime() - ts) / 1000)
            },
        })
    }

    _saveRequest = (requestData: object) => {
        if (this.config.isKeepLastSearchRequest) {
            localStorage.setItem(this.config.localStorageFields.prevRequestField, JSON.stringify(requestData))
        }
    }

    _updateSavedRequest = () => {
        if (!this.config.isKeepLastSearchRequest) {
            return
        }

        let storedRequestString = localStorage.getItem(this.config.localStorageFields.prevRequestField) + ""
        if (!storedRequestString) {
            return
        }

        let storedReuestData = JSON.parse(storedRequestString)

        if (!storedReuestData) {
            return
        }

        storedReuestData.index = this.activeIndex()
        localStorage.setItem(this.config.localStorageFields.prevRequestField, JSON.stringify(storedReuestData))
    }

    processClick = (item) => {
        localStorage.setItem(this.config.localStorageFields.isRestorePrevRequestFlag, "1")
        localStorage.setItem(this.config.localStorageFields.isRefererAutocompleteFlag, "1")

        window.location.href = item.url
    }

    getPrevSearchRequest = (): object => {
        if (this.prevSearchRequest && Object.entries(this.prevSearchRequest).length) {
            return this.prevSearchRequest
        }

        let latestQueryDataString = localStorage.getItem(
            this.config.localStorageFields.prevRequestField
        ) + ""

        if (!latestQueryDataString) {
            return {}
        }

        let latestQueryData = JSON.parse(latestQueryDataString)
        if (!latestQueryData) {
            return {}
        }

        this.prevSearchRequest = latestQueryData
        return this.prevSearchRequest
    }
}
